import { render, staticRenderFns } from "./TerritoryPreview.vue?vue&type=template&id=28bfcf82&scoped=true&"
import script from "./TerritoryPreview.vue?vue&type=script&lang=js&"
export * from "./TerritoryPreview.vue?vue&type=script&lang=js&"
import style0 from "./TerritoryPreview.vue?vue&type=style&index=0&id=28bfcf82&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfcf82",
  null
  
)

export default component.exports